export default {"src":"/_next/static/media/10.c5dafc0f.svg","height":42,"width":93,"blurWidth":0,"blurHeight":0};